// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"975175a12f8a0e92","4999":"4d776aa2e84299ba","7435":"79afa85f256e3cd0"}[chunkId] + ".css";
};